const normalizeToTriggersAPI = data => {
  return data.botPromptTriggerSettings;
};

export default normalizeToTriggersAPI;
